<template lang="pug">
svg.time-marker-figure(
  width="10"
  height="23"
  viewBox="0 0 10 23"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
)
  path(
    d="M1.9668 0C3.05303 0 3.93359 0.880565 3.93359 1.9668V6.83496C4.02133 6.8614 4.10814 6.90043 4.19141 6.9541L9.40723 10.3164C10.0178 10.7103 10.0178 11.6032 9.40723 11.9971L4.19141 15.3594C4.10814 15.413 4.02133 15.4521 3.93359 15.4785V20.3467C3.93359 21.4329 3.05303 22.3135 1.9668 22.3135C0.880565 22.3135 0 21.4329 0 20.3467V1.9668C0 0.880565 0.880565 0 1.9668 0Z"
  )
</template>

<script>
export default {
  name: 'IconTimeMarkerStart',
};
</script>
